import DashboardTabModule from './dashboard/dashboard';
import ChangePasswordTabModule from './changePassword/changePassword';
import TotpTabModule from './totp/totp';
import AddTotpTabModule from './addTotp/addTotp';
import DeleteAccountModule from './deleteAccount/deleteAccount';

export default angular
  .module('main.profile.tabs', [
    DashboardTabModule,
    ChangePasswordTabModule,
    TotpTabModule,
    AddTotpTabModule,
    DeleteAccountModule,
  ])
  .name;
